import { clearModuleHierarchyHighlightStyles } from './applyModuleHierarchyHighlightStyles';

/**
 * 메인에서 Array를 바꿀 때와 동일: 지도에는 현재 선택 범위만 둔다.
 * 선택 없음(페이지 이탈·복귀 후 새 선택 전)이면 source를 비우고 Feature 스타일도 지운다.
 */
export function clearHierarchyMapSelection({ source, features } = {}) {
  const fromSource =
    typeof source?.getFeatures === 'function' ? source.getFeatures() || [] : [];
  clearModuleHierarchyHighlightStyles([...(features || []), ...fromSource]);
  source?.clear?.();
}

export function isSolarModulePolygonLayer(layer) {
  return (
    layer?.get?.('name') === 'solar-module-layer' ||
    layer?.get?.('layerKind') === 'solar_module'
  );
}

/** 이전 방문에서 남은 모듈 폴리곤 레이어가 새 선택과 겹치지 않게 한다. */
export function removeSolarModulePolygonLayers(map, keepLayer = null) {
  const layers = map?.getLayers?.()?.getArray?.();
  if (!layers?.length) return [];
  const removed = [];
  [...layers].forEach(layer => {
    if (layer === keepLayer) return;
    if (!isSolarModulePolygonLayer(layer)) return;
    map.removeLayer(layer);
    removed.push(layer);
  });
  return removed;
}

/**
 * 페이지 복귀 후 새 OL Map에 레이어가 안 붙어 있으면 책갈피만 보이고 폴리곤이 안 보인다.
 * leftover 모듈 레이어는 제거하고, keep 레이어는 현재 map에 붙인다.
 */
export function replaceSolarModulePolygonLayerOnMap(map, layer) {
  if (!map || !layer) return;
  removeSolarModulePolygonLayers(map, layer);
  const layers = map.getLayers?.()?.getArray?.() || [];
  if (!layers.includes(layer) && typeof map.addLayer === 'function') {
    map.addLayer(layer);
  }
}
